import { render, staticRenderFns } from "./moreSearch.vue?vue&type=template&id=2214acac&scoped=true&"
import script from "./moreSearch.vue?vue&type=script&lang=js&"
export * from "./moreSearch.vue?vue&type=script&lang=js&"
import style0 from "./moreSearch.vue?vue&type=style&index=0&id=2214acac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2214acac",
  null
  
)

export default component.exports